export default __webpack_public_path__ + "static/media/search.1b0e6592.svg";